import React from 'react'
export function handleFormEvent<T = HTMLFormElement>(callback: (e: React.FormEvent<T>) => void) {
  return (e: React.FormEvent<T>) => {
    e.preventDefault();
    e.stopPropagation();
    callback(e);
  }
}
